import header from 'i18n/default/pl/header.json';
import mainMenu from 'i18n/default/pl/mainMenu';
import pendingPaymentAdvice from 'i18n/default/pl/pendingPaymentAdvice';
import PalletType from 'i18n/default/pl/PalletType';
import LiteralCurrency from 'i18n/default/pl/LiteralCurrency';
import units from 'i18n/default/pl/units';
import CustomPalletSize from 'i18n/default/pl/CustomPalletSize';
import NumberOfItems from 'i18n/default/pl/NumberOfItems';
import LoadInfo from 'i18n/default/pl/LoadInfo';
import LoadInputs from 'i18n/default/pl/LoadInputs';
import dates from 'i18n/default/pl/dates';
import Addresses from 'i18n/default/pl/Addresses';
import AddressFormModal from 'i18n/default/pl/AddressFormModal';
import AddressSelector from 'i18n/default/pl/AddressSelector';
import StopAddress from 'i18n/default/pl/StopAddress';
import Quote from 'i18n/default/pl/Quote';
import extraNames from 'i18n/default/pl/extraNames';
import timePickers from 'i18n/default/pl/timePickers';
import authLoginForm from 'i18n/default/pl/authLoginForm';
import authSignUpForm from 'i18n/default/pl/authSignUpForm';
import HandlingExtra from 'i18n/default/pl/HandlingExtra';
import Stop from 'i18n/default/pl/Stop';
import VehicleExtras from 'i18n/default/pl/VehicleExtras';
import OrderStop from 'i18n/default/pl/OrderStop';
import ShipmentCard from 'i18n/default/pl/ShipmentCard';
import Orders from 'i18n/default/pl/Orders';
import Summary from 'i18n/default/pl/Summary';
import Login from 'i18n/default/pl/Login';
import AddressesPage from 'i18n/default/pl/AddressesPage';
import ModalSummary from 'i18n/default/pl/ModalSummary';
import OrderSummary from 'i18n/default/pl/OrderSummary';
import OrdersOrderDetail from 'i18n/default/pl/OrdersOrderDetail';
import Order from 'i18n/default/pl/Order';
import ModalOrderDetail from 'i18n/default/pl/ModalOrderDetail';
import loads from 'i18n/default/pl/loads';
import SuggestedTimes from 'i18n/default/pl/SuggestedTimes';
import Downloads from 'i18n/default/pl/Downloads';
import CreditCard from 'i18n/default/pl/CreditCard';
import TypeOfOrderSelector from 'i18n/default/pl/TypeOfOrderSelector';
import Recurring from 'i18n/default/pl/Recurring';
import Settings from 'i18n/default/pl/Settings';
import InviteUserModal from 'i18n/default/pl/InviteUserModal';
import PaymentData from 'i18n/default/pl/PaymentData';
import DriverMapError from 'i18n/default/pl/DriverMapError';
import Faqs from 'i18n/default/pl/Faqs';
import AdditionalDocuments from 'i18n/default/pl/AdditionalDocuments';
import Communications from 'i18n/default/pl/Communications';
import RecurringOrderSuggestions from 'i18n/default/pl/RecurringOrderSuggestions';
import Error from 'i18n/default/pl/Error';
import Users from 'i18n/default/pl/Users';
import Tracking from 'i18n/default/pl/Tracking';
import Dashboard from 'i18n/default/pl/Dashboard';
import Catalog from 'i18n/default/pl/Catalog';
import Emergencies from 'i18n/default/pl/Emergencies';
import SignUp from 'i18n/default/pl/SignUp';
import Profile from 'i18n/default/pl/Profile';
import Landing from 'i18n/default/pl/Landing';

const lang = {
  Emergencies,
  Catalog,
  header,
  mainMenu,
  pendingPaymentAdvice,
  PalletType,
  LiteralCurrency,
  units,
  CustomPalletSize,
  NumberOfItems,
  LoadInfo,
  LoadInputs,
  dates,
  AddressFormModal,
  AddressSelector,
  StopAddress,
  Quote,
  extraNames,
  timePickers,
  authLoginForm,
  authSignUpForm,
  HandlingExtra,
  Stop,
  VehicleExtras,
  OrderStop,
  ShipmentCard,
  Orders,
  Summary,
  Login,
  AddressesPage,
  OrdersOrderDetail,
  ModalSummary,
  OrderSummary,
  Order,
  ModalOrderDetail,
  loads,
  SuggestedTimes,
  Downloads,
  CreditCard,
  Addresses,
  TypeOfOrderSelector,
  Recurring,
  Settings,
  InviteUserModal,
  PaymentData,
  DriverMapError,
  Faqs,
  AdditionalDocuments,
  Communications,
  RecurringOrderSuggestions,
  Error,
  Users,
  Tracking,
  Dashboard,
  SignUp,
  Profile,
  Landing
};

export default lang;
